import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTimezone = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 26,
	height: 26,
	viewBox: "0 0 26 26",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		opacity: .5,
		children: [
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M2.05664 10.6653C3.10529 5.62008 7.57613 1.8291 12.9324 1.8291C19.0674 1.8291 24.0407 6.80247 24.0407 12.9374C24.0407 18.2937 20.2497 22.7646 15.2045 23.8132C15.8734 23.1775 16.4478 22.4433 16.9045 21.6339C19.0232 20.6646 20.7263 18.9438 21.6726 16.8124H18.0955C18.0811 16.2836 18.0225 15.7657 17.9233 15.2624H22.206C22.392 14.5182 22.4907 13.7393 22.4907 12.9374C22.4907 12.1355 22.392 11.3567 22.206 10.6124H17.6304C17.7536 11.3723 17.8244 12.1437 17.8406 12.9213C17.8408 12.9321 17.8408 12.9428 17.8406 12.9536C17.8298 13.4696 17.795 13.9829 17.7369 14.492C17.4114 13.3619 16.8774 12.3202 16.1792 11.4111C16.146 11.1435 16.1055 10.8771 16.058 10.6124H15.4908C14.9115 10.0123 14.2523 9.48994 13.5302 9.06243H15.6944C15.1369 7.14856 14.2014 5.3544 12.9324 3.79112C11.9159 5.0433 11.1134 6.44361 10.5478 7.93493C10.0315 7.83669 9.50003 7.78114 8.95727 7.77209C9.48552 6.26771 10.2299 4.84169 11.1716 3.54094C8.07844 4.11694 5.50902 6.18258 4.23594 8.9653C3.4265 9.42197 2.69232 9.99637 2.05664 10.6653ZM21.6726 9.06243H17.3024C16.7834 7.08193 15.9005 5.20851 14.6932 3.54094C17.8222 4.12362 20.4153 6.23071 21.6726 9.06243Z",
				fill: "#360802"
			}),
			/* @__PURE__ */ _jsx("ellipse", {
				cx: 8.79961,
				cy: 17.0701,
				rx: 6.2,
				ry: 6.2,
				stroke: "#360802",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M8.02539 13.4541H9.57539V16.2958H11.3837V17.8458H10.2754C9.03275 17.8458 8.02539 16.8384 8.02539 15.5958V13.4541Z",
				fill: "#360802"
			})
		]
	})
});
export default SvgTimezone;
